import styled, { createGlobalStyle } from 'styled-components';
import { palette } from 'styles/colors';

export const StyledMain = styled.main`
  font-family: Mulish, sans-serif;
  color: ${palette.text};
  font-size: 16px;
  overflow-x: hidden;

  & > div:not(#header) {
    max-width: 1440px;
    margin: 0 auto;
  }

  video {
    clip-path: inset(1px 1px); // remove black borders on windows
  }
`;

interface LayoutBodyStylesProps {
  backgroundColor?: string;
  width?: string;
}

export const LayoutBodyStyles = createGlobalStyle<LayoutBodyStylesProps>`
  body {
    margin: 0;
    overflow-x: hidden;
    text-rendering: optimizeSpeed;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    width: ${({ width }) => width};
    ${({ backgroundColor }) => (!backgroundColor ? '' : `background-color: ${backgroundColor};`)}
  }
`;
